import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/api";

const ContentContext = createContext({});

export const useContent = () => useContext(ContentContext) || {};

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api
      .get("/content")
      .then((r) => setContent(r.data))
      .catch(() => setContent({}));
  }, []);

  useEffect(() => {
    const ga = content?.integrations?.ga4_id;
    if (ga && !document.getElementById("ga4-script")) {
      const s = document.createElement("script");
      s.id = "ga4-script";
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${ga}`;
      document.head.appendChild(s);
      const inline = document.createElement("script");
      inline.id = "ga4-inline";
      inline.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments)}gtag('js',new Date());gtag('config','${ga}');`;
      document.head.appendChild(inline);
    }
  }, [content]);

  useEffect(() => {
    if (!sessionStorage.getItem("mp_tracked")) {
      sessionStorage.setItem("mp_tracked", "1");
      api.post("/track").catch(() => {});
    }
  }, []);

  return (
    <ContentContext.Provider value={content || {}}>
      {children}
    </ContentContext.Provider>
  );
}
